import {defineMessages} from 'react-intl';

export default defineMessages({
  heading: {
    defaultMessage: 'in collaboration with',
    id: 'Player.ElementsDisplay.ProvidersElement.Heading',
  },
});
